module.exports = __webpack_public_path__ + "static/media/hunger.2b986ea8.png";